import { ReactNode } from 'react'
import { LinkAnchor } from './LinkAnchor'
import { Style } from 'inlines'

export const LinkWrapper = ({
  to,
  style,
  children,
}: {
  to: string
  style?: Style
  children: ReactNode
}) => {
  return (
    <LinkAnchor
      to={to}
      style={{
        textDecoration: 'none',
        ...style,
      }}
    >
      {children}
    </LinkAnchor>
  )
}
